import { Link, useLocation } from 'react-router-dom';

const breadcrumbMap: Record<string, string> = {
  '/': '首页',
  '/category': '分类',
  '/category/love': '恋爱',
  '/category/fantasy': '奇幻',
  '/category/action': '动作',
  '/category/suspense': '悬疑',
  '/about': '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (location.pathname === '/') return null;

  const breadcrumbs = [{ label: '首页', path: '/' }];

  if (pathnames[0] === 'category' && pathnames[1]) {
    breadcrumbs.push({ label: '分类', path: '/category/' + pathnames[1] });
    breadcrumbs.push({ label: breadcrumbMap['/category/' + pathnames[1]] || pathnames[1], path: location.pathname });
  } else if (pathnames[0] === 'comic') {
    breadcrumbs.push({ label: '漫画详情', path: location.pathname });
  } else if (pathnames[0] === 'about') {
    breadcrumbs.push({ label: '关于我们', path: '/about' });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 pt-20 pb-2">
      <ol className="flex items-center gap-2 text-sm flex-wrap">
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return (
            <li key={item.path} className="flex items-center gap-2">
              {!isLast ? (
                <>
                  <Link
                    to={item.path}
                    className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                  <span className="text-foreground-400">
                    <i className="ri-arrow-right-s-line text-xs w-3 h-3 flex items-center justify-center" />
                  </span>
                </>
              ) : (
                <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}